import sigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteUser = async ({ id }) => {
  const { data } = await sigliveServiceV1({
    method: 'DELETE',
    url: `/user/${id}`,
  });

  return data;
};

export default deleteUser;
